import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { ActiveState, EntityState, EntityStore } from "@datorama/akita";
import { IMilestone } from "@common/interfaces/milestone";

export interface MilestoneState extends EntityState<IMilestone, string>, ActiveState { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.MILESTONES , realtimeEntity: 'Milestone'})
export class MilestoneStore extends EntityStore<MilestoneState> {

  constructor() {
    super([]);
  }

}
